import { AssignmentRead } from 'src/common/external/bambi-api/bambiApi';

export function getAssignmentById(
  assignmentId: string,
  assignments: AssignmentRead[]
): AssignmentRead | undefined {
  return assignments.find((assignment) => assignment.id === assignmentId);
}
